export default "__VITE_ASSET__D1_xF3WZ__"